import React from "react";
import { number, string } from "prop-types";

const CommentIcon = ({ color = "#999999", width = 32, height = 32 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 32 32.002">
    <defs />
    <path
      fill={color}
      d="M268 240.014h-24a4 4 0 0 0-4 4v18a4 4 0 0 0 4 4h6v5.25a.751.751 0 0 0 1.194.606l7.806-5.856h9a4 4 0 0 0 4-4v-18a4 4 0 0 0-4-4z"
      transform="translate(-240 -240.014)"
    />
  </svg>
);

CommentIcon.propTypes = {
  width: number,
  height: number,
  color: string
};

export default CommentIcon;
